export const S3_URL = 'https://static.solartrip.com/images/';

export const LOGO = {
  DESKTOP: `${S3_URL}solartrip/logo.svg`,
  MOBILE: `${S3_URL}solartrip/app-icon.svg`,
};

export const PRODUCTS = {
  AVIA: 'avia',
  HOTELS: 'hotels',
};

export const APP_LINK =
  'https://slr.onelink.me/gEAA?af_web_dp=https%3A%2F%2Fsolartrip.com%2Fen-us%2Floyalty%2Fapp&af_xp=custom&pid=Order_sharing&c=landing';
